import microuniversoApi from "app/api/microuniversoApi"
import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"
import {Entrega} from "../../components/entrega/aba-entrega/aba-entrega";
declare var window:any
export type AtualizarEntregaInput = {
    dados: Entrega
}
export async function atualizarEntrega(input: AtualizarEntregaInput) {
    const parteOrcamento = await microuniversoApi.Orcamento.atualizarEntrega(
       input.dados
    )
    const atualizarOrcamentoLegadoERedux = () => {
        const orcamentoLegado = window.orcamentoController.model
        const orcamentoReact = store.getState().orcamento
        orcamentoLegado.atualizar({
            ...orcamentoLegado,
            ...parteOrcamento
        })
        store.dispatch(sobrescreverInformacoesAction({
            ...orcamentoReact,
            ...parteOrcamento
        }))
    }
    atualizarOrcamentoLegadoERedux()
}
